import React from 'react';
import MultiSlider from '../MultiSlider';
import BlockContainer from './BlockContainer';
import Button from '../Button';
import useTeams from '../../utils/useTeam';

const prefix =
  process.env.NODE_ENV === 'production'
    ? 'https://img.paperform.co/fetch/w_601,f_auto/'
    : '';

function getTeam(team, teamList) {
  return teamList[team]?.map(
    ({ node: { name, preferred_name, image, carousel_image } }, i) => (
      <div key={i} className="mx-2">
        <div
          title={preferred_name || name}
          className="w-full aspect-square relative m-0 bg-center bg-cover rounded-2xl after:content-[attr(title)] after:block after:px-3 after:py-1 after:bg-midnight after:text-white after:text-sm after:absolute after:bottom-2 after:left-2 after:rounded-2xl"
          style={{
            backgroundImage: `url(${prefix}${carousel_image || image})`,
          }}
        />
      </div>
    ),
  );
}

export default function TeamCarousel({
  title,
  description,
  team = 'All',
  bgColor,
  textColor,
  padding,
  link,
}) {
  const teamList = useTeams([team]);
  const renderTeam = getTeam(team, teamList);
  const hasLink = link?.link_text && link?.link_url;

  return (
    <BlockContainer
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
      title={title}
      description={description}
    >
      <p
        className="text-center text-white mb-4 font-bold"
        style={{ color: textColor }}
      >
        Meet our {team === 'All' ? '' : team} team
      </p>
      <MultiSlider textColor={textColor} hasButton={hasLink}>
        {renderTeam}
      </MultiSlider>
      {hasLink ? (
        <Button
          color={textColor === 'var(--text-light)' ? 'white' : 'midnight'}
          to={link.link_url}
          lg
        >
          {link.link_text}
        </Button>
      ) : null}
    </BlockContainer>
  );
}
